import type { AudioAnnouncementDevice } from '../../../API/types/AudioAnnouncement';

export const TIMEOUT_DEFAULT_MINUTES = 15;

export function getStartOfToday(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function getMinDateTime(): Date {
  const d = new Date();
  d.setTime(d.getTime() + TIMEOUT_DEFAULT_MINUTES * 60 * 1000);
  return d;
}

export function getDefaultTimeoutDate(): Date {
  return getMinDateTime();
}

export function getDeviceDisplayId(device: AudioAnnouncementDevice | null | undefined): string {
  if (device == null) return '';
  return (device.deviceId ?? device._id ?? '').trim();
}
